(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .factory('PosIncomeReportViewModel', PosIncomeReportViewModelFactory);

  /** @ngInject */
  function PosIncomeReportViewModelFactory(
    reportActions,
    reportsFilterStore,
    $translate,
    localeFilters,
    dispatcher,
    ActionTypesEnum
  ) {
    function PosIncomeReportViewModel() {
      this._reportsFilterStoreChangeHandler = null;
      this.chart = {
        data: null,
        x: {
          tick: {
            culling: { max: 15 },
            rotate: 60,
            format: function (xItem) {
              return $translate.instant(localeFilters.date(xItem));
            }
          }
        }
      };

      init.call(this);
    }

    PosIncomeReportViewModel.prototype.destroy = function () {
      reportsFilterStore.off(
        reportsFilterStore.events.CHANGE,
        this._reportsFilterStoreChangeHandler
      );
    };

    return PosIncomeReportViewModel;

    function init() {
      var that = this;
      this.isChartVisible = false;

      searchByFilter.call(that);
      this._reportsFilterStoreChangeHandler = function () {
        searchByFilter.call(that);
      };

      reportsFilterStore.on(
        reportsFilterStore.events.CHANGE,
        this._reportsFilterStoreChangeHandler
      );
    }

    function searchByFilter() {
      var that = this,
        reportFilterData = reportsFilterStore.getFilterData();

      reportActions
        .getPosIncome(
          reportFilterData.selectedFacilitySerial,
          reportFilterData.fromTimestamp,
          reportFilterData.toTimestamp,
          reportFilterData.currency
        )
        .then(function (successData) {
          that.chart.data = successData;
          successData.groupsData.map(function (data) {
            //Increase day index by 1 to get proper schedule in the table (6 is sunday)
            data.groupValue = data.groupValue === 6 ? 0 : data.groupValue + 1;
          });
          that.isChartVisible = successData.total !== 0;
          dispatcher.dispatch({
            type: ActionTypesEnum.HIDE_LOADER
          });
        });
    }
  }
})();
